import { useSessionStore } from '@/stores/SessionStore'
import { useUserStore } from '@/stores/UserStore'
import { useCachedFetch } from '@/composables/useFetch'
import useConfigurationGlobals from '@/composables/useConfigurationGlobals'

const { $BASEURL } = useConfigurationGlobals();

export const useApiData = (group) => {
  const request = async (endPoint, options, overrideCache = false) => {
    const sessionStore = useSessionStore();
    const userStore = useUserStore()
  
    const params = {
      ...options,
      units_wind: userStore.unitsWind,
      units_temp: userStore.unitsTemp,
      units_distance: userStore.unitsDistance,
      units_precip: userStore.unitsPrecip,
      wf_token: sessionStore.token
    }
  
    const queryString = new URLSearchParams(params).toString()
    const url = `${$BASEURL}/${group}/${endPoint}?${queryString}`
  
    try {
      const { error, data } = await useCachedFetch(url, {}, true, overrideCache)
  
      if (error.value) {
        throw error.value
      }
  
      if (data.value.status?.status_code !== 0 && data.value.status_code !== 0) {
        throw data.value.status || data.value.status_code
      }
  
      return {error, data}
    } catch (error) {
      console.warn(error)
  
      return error
    }
  }

  return { request }
}
